module.exports = __webpack_public_path__ + "img/carousel_4.d57cc567.jpg";